import React, { useEffect, useState } from "react";
import { Form, Col, Row, Container, Image } from "react-bootstrap";
import PropTypes from 'prop-types';
import BackNext from '../../Common/SubComponents/BackNext';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { customValidators, object, string } from '../../../Helpers/Validators/customValidators';
import { SelectInput, TextInput, StyledRadioInput } from "../../../Helpers/Inputs";
import { CollapsibleBasicInfoSummary } from '../../Common/SubComponents/BasicInfoSummary';
import { InputMaskZip, InputMaskHeight, InputMaskWeight } from '../../../Helpers/Formatters';
import TimeZones from '../../Common/Appointment/Timezones';
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined.js';
import StatesWithDisabled from '../../../Helpers/Lists/StatesWithDisabled';
import { IconButton, SvgIcon, Tooltip, withStyles } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import States from '../../../Helpers/Lists/States';
import Step2Icon from '../icons/step_2.svg';
import SingleIcon from '../icons/single.svg';
import MarriedIcon from '../icons/married.svg';
import { getBasicInfo, setBasicInfo } from '../../../../sessionStorage';
import InfoIcon from '@material-ui/icons/Info';

export default function GettingToKnowYou(props) {

  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: GettingToKnowYou.ValidationSchema(props.ageSpecs),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };

  useEffect(() => {
    register({ name: 'mailingState' });
    setValue('mailingState', props.basicInfo.state);

    register({ name: 'state' });
    setValue('state', props.basicInfo.state);

    register({ name: 'maritalStatus' });
    setValue('maritalStatus', props.formState.maritalStatus);

    register({ name: 'height' });
    setValue('height', props.formState.height);

    register({ name: 'weight' });
    setValue('weight', props.formState.weight);

    register({ name: 'mailingAdressISPOBox' });
    setValue('mailingAdressISPOBox', props.formState.mailingAdressISPOBox);

    register({ name: 'sameAsStreetAddress' });
    setValue('sameAsStreetAddress', props.formState.sameAsStreetAddress);

    register({ name: 'residenceLessThanFive' });
    setValue('residenceLessThanFive', props.formState.residenceLessThanFive);

    register({ name: 'ownerIsProposedInsured' });
    setValue('ownerIsProposedInsured', props.formState.ownerIsProposedInsured);

    register({ name: 'proposedInsuredIsUSCitizen' });
    setValue('proposedInsuredIsUSCitizen', props.formState.proposedInsuredIsUSCitizen);

    register({ name: 'proposedInsuredIsPermanentResident' });
    setValue('proposedInsuredIsPermanentResident', props.formState.proposedInsuredIsPermanentResident);

    register({ name: 'timeZone' });
    setValue('timeZone', props.formState.timeZone);

  }, [register]);

  const [helpDialogOpen, setHelpDialogOpen] = useState(false);

  //running onfieldchange for each causes race conditions
  useEffect(() => {
    let form = { ...props.fullFormState };
    form.steps.gettingToKnowYou.mailingState = props.basicInfo.state;
    form.steps.gettingToKnowYou.state = props.basicInfo.state;
    setValue('height', props.basicInfo.height);
    form.steps.gettingToKnowYou.height = props.basicInfo.height;
    setValue('weight', props.basicInfo.weight);
    form.steps.gettingToKnowYou.weight = props.basicInfo.weight;
    props.onMultiFieldChange(form);
  }, []);

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: 14,
      boxShadow: theme.shadows[1],
    },
  }))(Tooltip);

  const label = (<span>Is the proposed insured also the owner of the policy?
    <LightTooltip title="The owner of a policy is the one who makes the premium payments and assigns the beneficiary. The insured is the individual who is covered under the policy." placement="top" enterTouchDelay={0} ><InfoIcon className="ml-2" /></LightTooltip>
  </span>);

  const onSubmit = () => {
    const basicInfoFromSessionStorage = getBasicInfo();
    const form = { ...props.fullFormState };
    basicInfoFromSessionStorage.height = props.formState.height;
    basicInfoFromSessionStorage.weight = props.formState.weight;
    setBasicInfo(basicInfoFromSessionStorage);
    form.steps.basicInfo.height = props.formState.height;
    form.steps.basicInfo.weight = props.formState.weight;
    props.onMultiFieldChange(form);
    props.onNext();
  };

  return (
    <Container>
      <Row className="formPage justify-content-center">
        <Col lg={6}>
          <Row className="justify-content-center">
            <SvgIcon component={Step2Icon} className="headerIcon" />
          </Row>
          <h4 className="headerTitle">Getting to know you</h4>
          <h5 className="headerSubtitle">Your demographics are key variables to a personalized rate.</h5>

          <CollapsibleBasicInfoSummary
            gender={props.basicInfo.gender}
            state={props.basicInfo.state}
            birthdate={props.basicInfo.birthdate}
            tobacco={(props.basicInfo.tobacco !== 'Never').toString()}
            height={props.formState.height}
            weight={props.formState.weight}
            showEditLink={true}
            showDash={true}
            editLinkOnClick={props.onEditBasicInfo}
          />

          <form className="quote-form" onSubmit={handleSubmit(onSubmit)}>

            <br />

            <StyledRadioInput
              name="maritalStatus"
              id="maritalStatus"
              value={props.formState.maritalStatus}
              options={[
                { value: "single", label: "Single", icon: <SingleIcon fontSize="large" /> },
                { value: "married", label: "Married", icon: <MarriedIcon fontSize="large" /> }]}
              onChange={e => handleValueChange('maritalStatus', e)}
              errors={errors.maritalStatus}
            />

            <Row>
              <Col>
                <Form.Group>
                  <TextInput
                    name="height"
                    id="height"
                    label="Height"
                    value={props.formState.height}
                    errors={errors.height}
                    inputRef={register}
                    onChange={e => handleValueChange('height', e.target.value)}
                    InputProps={{
                      inputComponent: InputMaskHeight,
                    }}
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group>
                  <TextInput
                    name="weight"
                    id="weight"
                    label="Weight"
                    value={props.formState.weight}
                    errors={errors.weight}
                    inputRef={register}
                    onChange={e => handleValueChange('weight', e.target.value)}
                    InputProps={{
                      inputComponent: InputMaskWeight,
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <h6>Street Address</h6>

            <Form.Group>
              <TextInput
                name="street"
                id="street"
                label="Address"
                value={props.formState.street}
                onChange={e => props.onFieldChange('street', e.target.value)}
                errors={errors.street}
                inputRef={register}
              />
            </Form.Group>

            <Form.Group>
              <TextInput
                name="city"
                id="city"
                label="City"
                value={props.formState.city}
                onChange={e => props.onFieldChange('city', e.target.value)}
                errors={errors.city}
                inputRef={register}
              />
            </Form.Group>

            <Row>
              <Col>
                <SelectInput
                  name="state"
                  id="state"
                  value={props.formState.state}
                  onChange={(e) => handleValueChange('state', e.target.value)}
                  label="State"
                  selectOptions={StatesWithDisabled(["NY"])}
                  errors={errors.state}
                  inputRef={register}
                  disabled
                />
              </Col>
              <Col>
                <Form.Group>
                  <TextInput
                    name="zip"
                    id="zip"
                    label="Zip"
                    value={props.formState.zip}
                    onChange={e => props.onFieldChange('zip', e.target.value)}
                    errors={errors.zip}
                    inputRef={register}
                    InputProps={{
                      inputComponent: InputMaskZip,
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group>
                  <SelectInput
                    name="timeZone"
                    id="timeZone"
                    value={props.formState.timeZone}
                    errors={errors.timeZone}
                    onChange={(e) => handleValueChange('timeZone', e.target.value)}
                    label="Timezone"
                    selectOptions={TimeZones}
                    inputRef={register}
                  />
                </Form.Group>
              </Col>
            </Row>

            <StyledRadioInput
              name="sameAsStreetAddress"
              id="sameAsStreetAddress"
              label="Is the mailing address the same as the street address?"
              value={props.formState.sameAsStreetAddress}
              options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
              onChange={e => handleValueChange('sameAsStreetAddress', e)}
              errors={errors.sameAsStreetAddress}
            />

            {props.formState.sameAsStreetAddress === "false" &&
              <React.Fragment>
                <h6>Mailing Address</h6>

                <StyledRadioInput
                  name="mailingAdressISPOBox"
                  id="mailingAdressISPOBox"
                  label="Is the mailing address a PO Box?"
                  value={props.formState.mailingAdressISPOBox}
                  options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                  onChange={e => handleValueChange('mailingAdressISPOBox', e)}
                  errors={errors.mailingAdressISPOBox}
                />

                <Form.Group>
                  <TextInput
                    name="mailingStreet"
                    id="mailingStreet"
                    label="Mailing Address"
                    value={props.formState.mailingStreet}
                    onChange={e => props.onFieldChange('mailingStreet', e.target.value)}
                    errors={errors.mailingStreet}
                    inputRef={register}
                  />
                </Form.Group>

                <Form.Group>
                  <TextInput
                    name="mailingCity"
                    id="mailingCity"
                    label="Mailing City"
                    value={props.formState.mailingCity}
                    onChange={e => props.onFieldChange('mailingCity', e.target.value)}
                    errors={errors.mailingCity}
                    inputRef={register}
                  />
                </Form.Group>

                <Row>
                  <Col>
                    <Form.Group>
                      <SelectInput
                        name="mailingState"
                        id="mailingState"
                        value={props.formState.mailingState}
                        onChange={(e) => handleValueChange('mailingState', e.target.value)}
                        label="Mailing State"
                        selectOptions={StatesWithDisabled(["NY"])}
                        errors={errors.mailingState}
                        inputRef={register}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <TextInput
                        name="mailingZip"
                        id="mailingZip"
                        label="Mailing Zip"
                        value={props.formState.mailingZip}
                        onChange={e => props.onFieldChange('mailingZip', e.target.value)}
                        errors={errors.mailingZip}
                        inputRef={register}
                        InputProps={{
                          inputComponent: InputMaskZip,
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </React.Fragment>
            }

            <Form.Group>
              <StyledRadioInput
                name="residenceLessThanFive"
                id="residenceLessThanFive"
                label="Has the proposed insured lived at their current address for less than 5 years?"
                value={props.formState.residenceLessThanFive}
                options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                onChange={e => handleValueChange('residenceLessThanFive', e)}
                errors={errors.residenceLessThanFive}
              />
            </Form.Group>

            {props.formState.residenceLessThanFive === "true" &&
              <Form.Group>
                <TextInput
                  name="insuredPriorZip"
                  id="insuredPriorZip"
                  label="What is the Proposed Insured's prior zip code?"
                  value={props.formState.insuredPriorZip}
                  onChange={e => props.onFieldChange('insuredPriorZip', e.target.value)}
                  errors={errors.insuredPriorZip}
                  inputRef={register}
                  InputProps={{
                    inputComponent: InputMaskZip,
                  }}
                />
              </Form.Group>
            }

            <Form.Group>
              <StyledRadioInput
                name="ownerIsProposedInsured"
                id="ownerIsProposedInsured"
                label={label}
                value={props.formState.ownerIsProposedInsured}
                options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                onChange={e => handleValueChange('ownerIsProposedInsured', e)}
                errors={errors.ownerIsProposedInsured}
              />
            </Form.Group>

            <Form.Group>
              <StyledRadioInput
                name="proposedInsuredIsUSCitizen"
                id="proposedInsuredIsUSCitizen"
                label="Is the Proposed Insured a US citizen?"
                value={props.formState.proposedInsuredIsUSCitizen}
                options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                onChange={e => handleValueChange('proposedInsuredIsUSCitizen', e)}
                errors={errors.proposedInsuredIsUSCitizen}
              />
            </Form.Group>

            {props.formState.proposedInsuredIsUSCitizen === "false" && (
              <div>
                <Form.Group>
                  <StyledRadioInput
                    name="proposedInsuredIsPermanentResident"
                    id="proposedInsuredIsPermanentResident"
                    label="Is the Proposed Insured a Permanent Resident?"
                    value={props.formState.proposedInsuredIsPermanentResident}
                    options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => handleValueChange('proposedInsuredIsPermanentResident', e)}
                    errors={errors.proposedInsuredIsPermanentResident}
                  />
                </Form.Group>

                {props.formState.proposedInsuredIsPermanentResident === "true" && (
                  <div>
                    <div className="text-center mb-4">
                      <Image src={`${process.env.PUBLIC_URL}/americo/Green-Card.jpg`} alt={'Green Card Logo'} />
                    </div>
                    <Form.Group>
                      <TextInput
                        name="visaGreenCardId"
                        id="visaGreenCardId"
                        label="Permanent Resident Visa or Green Card ID #"
                        value={props.formState.visaGreenCardId}
                        onChange={e => props.onFieldChange('visaGreenCardId', e.target.value)}
                        errors={errors.visaGreenCardId}
                        inputRef={register}
                      />
                    </Form.Group>
                    <div className="mb-3">
                      A copy of the Permanent Resident Visa or Green Card must be provided to underwriting as a delivery requirement. Please send by email to <a href="mailto:submit@americo.com">submit@americo.com</a> or by fax to 800-395-9261.
                      <IconButton aria-label="help" size="small" onClick={() => setHelpDialogOpen(true)}>
                        <HelpOutlineIcon />
                      </IconButton>
                    </div>
                  </div>
                )}
              </div>
            )}

            {props.formState.proposedInsuredIsUSCitizen && (
              <Form.Group>
                <SelectInput
                  name="insuredStateOfBirth"
                  id="insuredStateOfBirth"
                  value={props.formState.insuredStateOfBirth}
                  onChange={(e) => handleValueChange('insuredStateOfBirth', e.target.value)}
                  label="Birth State"
                  selectOptions={[...States(), { label: 'Foreign Country', value: 'Foreign Country' }]}
                  errors={errors.insuredStateOfBirth}
                  inputRef={register}
                />
              </Form.Group>
            )}
            <BackNext onBack={props.onBack} />
          </form>
        </Col>
      </Row>
    </Container>
  );
}

GettingToKnowYou.ValidationSchema = (ageSpecs) => {
  return object().shape({
    maritalStatus: string()
      .required('Marital status is required.'),
    height: customValidators.string()
      .required('Height is required.')
      .isValidHeightString('Invalid height.', 3),
    weight: customValidators.string()
      .required('Weight is required.')
      .isValidWeightString('Please verify your weight has been entered correctly.', 78, 395),
    sameAsStreetAddress: string().required('This field is required.'),
    mailingAdressISPOBox: string().when("sameAsStreetAddress", {
      is: "false",
      then: string().required('This field is required.'),
      otherwise: string().notRequired(),
    }),
    mailingStreet: string().when("sameAsStreetAddress", {
      is: "false",
      then: customValidators.string().isValidNameLimitedSpecialChar('Mailing street address is required.', true, true),
      otherwise: string().notRequired()
    }),
    mailingCity: string().when("sameAsStreetAddress", {
      is: "false",
      then: string().isValidNameLimitedSpecialChar('Mailing city is required.', true, false),
      otherwise: string().notRequired()
    }),
    mailingState: string().when("sameAsStreetAddress", {
      is: "false",
      then: string().required('Mailing state is required.'),
      otherwise: string().notRequired()
    }),
    mailingZip: string().when("sameAsStreetAddress", {
      is: "false",
      then: customValidators.string().isValidNumbersOnly('Invalid zip', 5).required('Mailing zip is required.'),
      otherwise: string().notRequired()
    }),
    street: customValidators.string().isValidNameLimitedSpecialChar('Street address is required.', true, true),
    city: string().isValidNameLimitedSpecialChar('City is required.', true, false),
    state: string()
      .required('State is required.'),
    zip: customValidators.string()
      .isValidNumbersOnly('Invalid zip.', 5)
      .required('Zip is required.'),
    residenceLessThanFive: string()
      .required('This field is required.'),
    insuredPriorZip: string().when('residenceLessThanFive', {
      is: "true",
      then: customValidators.string().isValidNumbersOnly('Invalid zip.', 5).required('Zip is required.'),
      otherwise: string().notRequired()
    }),
    ownerIsProposedInsured: string()
      .required('This field is required.')
      .matches(/^true/, 'The owner must be the insured.'),
    proposedInsuredIsUSCitizen: string()
      .required("This field is required."),
    proposedInsuredIsPermanentResident: string().when('proposedInsuredIsUSCitizen', {
      is: "false",
      then: string()
        .required("This field is required.")
        .matches(/^true/, 'Coverage is not available due to citizenship status.'),
      otherwise: string().notRequired(),
    }),
    visaGreenCardId: string().when(['proposedInsuredIsUSCitizen', 'proposedInsuredIsPermanentResident'], {
      is: (proposedInsuredIsUSCitizen, proposedInsuredIsPermanentResident) => proposedInsuredIsUSCitizen === "false" && proposedInsuredIsPermanentResident === "true",
      then: customValidators.string()
        .required("Visa/Green Card number is required.")
        .isValidVisaNumber('Please re-enter a valid Visa/Green Card number.'),
      otherwise: string().notRequired(),
    }),
    insuredStateOfBirth: string().when('proposedInsuredIsUSCitizen', {
      is: "true",
      then: string().required("State of birth is required."),
      otherwise: string().notRequired(),
    }),
    timeZone: string().transform(emptyStringToUndefined).required("Timezone is required.")
  });
};

GettingToKnowYou.DefaultFormState = (prefill = false, basicInfo = null) => {

  let usResident = "";
  if (basicInfo && basicInfo.usResident === true) {
    usResident = "true";
  } else if (basicInfo && basicInfo.usResident === false) {
    usResident = "false";
  }

  return {
    maritalStatus: prefill ? "married" : "",
    height: prefill ? '5 ft 10 in' : '',
    weight: prefill ? '175 pounds' : '',
    mailingAdressISPOBox: "false",
    sameAsStreetAddress: "true",
    street: prefill ? "2020 Covr St" : "",
    city: prefill ? "Boise" : "",
    state: prefill ? "ID" : "",
    zip: prefill ? "83702" : "",
    mailingStreet: prefill ? "2020 Covr St" : "",
    mailingCity: prefill ? "Boise" : "",
    mailingZip: prefill ? "83702" : "",
    mailingState: prefill ? "ID" : "",
    residenceLessThanFive: prefill ? "false" : "",
    insuredPriorZip: prefill ? "83702" : "",
    ownerIsProposedInsured: prefill ? "true" : "",
    proposedInsuredIsUSCitizen: prefill ? "true" : usResident,
    proposedInsuredIsPermanentResident: prefill ? "true" : (usResident === "true" ? "" : usResident),
    visaGreenCardId: prefill ? "ABC1234567890" : "",
    insuredStateOfBirth: prefill ? "ID" : "",
    timeZone: (function () {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const tz1 = TimeZones.find(e => e.zone === tz);
      return tz1 ? tz1.value : '';
    })()
  };
};

GettingToKnowYou.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  ageSpecs: PropTypes.object.isRequired,
  fullFormState: PropTypes.object,
  basicInfo: PropTypes.object,
  onEditBasicInfo: PropTypes.func,
  onMultiFieldChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Americo/steps/GettingToKnowYou.js